import { ComponentType } from '$lib/sanity/types';
import groq from 'groq';

export const GetNewsRunningLaneQuery = groq`*[_id == $id && _type == "${ComponentType.NewsRunningLane}"][0]`;
